import { FunctionComponent, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Button from "../../../../generic/Button";
import { types } from "../../../../../utils";

const HeroContent: FunctionComponent = () => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(true);
  }, []);

  return (
    <div className="flex flex-col justify-center items-center lg:items-start lg:w-[50%] text-center lg:text-left py-16 px-6 relative z-10">
      
      {/* Main Title - 3D Neon style */}
      <h2
        className={`text-6xl lg:text-7xl font-sans font-extrabold text-white relative transition-transform duration-1000 ${
          animate ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-12"
        }`}
      >
        <span className="relative z-10 drop-shadow-[0_0_15px_rgba(0,106,182,0.7)]">
          ClientVitals
        </span>
        {/* Neon glow streak */}
        <span className="absolute inset-0 bg-gradient-to-r from-white/20 via-white/50 to-white/20 opacity-40 blur-sm"
        style={{ animation: 'shimmer-once 1.5s forwards' }}></span>
      </h2>

      {/* Subtitle - floating shimmer letters */}
      <p
        className={`text-4xl md:text-5xl lg:text-5xl font-josefin text-white mt-6 mb-4 relative transition-transform duration-1000 delay-200 ${
          animate ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"
        }`}
      >
        {/** Split letters for staggered float */}
        {"Stop Borrowing Stress".split("").map((letter, idx) => (
          <span
            key={idx}
            className="inline-block animate-float hover:animate-bounce transition-all duration-300"
            style={{ animationDelay: `${idx * 50}ms` }}
          >
            {letter}
          </span>
        ))}
        <span className="absolute inset-0 bg-gradient-to-r from-white/20 via-white/50 to-white/20 opacity-40 blur-sm"
        style={{ animation: 'shimmer-once 1.5s forwards' }}></span>
      </p>

      {/* CTA */}
      <div
        className={`mt-8 transition-transform duration-1000 delay-400 ${
          animate ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"
        }`}
      >
        <Link to="/auth/client-registration?tier=bronze">
          <Button
            text="Start For $5 Today"
            theme={types.buttonTypes.BUTTON_THEME_TYPES.WHITE}
            styles="w-[350px] lg:w-[600px] h-[60px] lg:h-[65px] p-0 text-xl tracking-widest font-normal mt-4 shadow-lg hover:shadow-strong transition-transform duration-300 hover:scale-105 active:scale-95 animate-pulse-once"
          />
        </Link>
      </div>
    </div>
  );
};

export default HeroContent;
